import { configValues } from 'src/config';

export const articles = () => [
  {
    title: 'How to buy a franchise',
    url: `${configValues.HEADER_SERVER_BASE}/business-resources/how-to-buy-a-franchise`,
    imageUrl: `${configValues.HEADER_SERVER_BASE}/wp-content/uploads/2018/09/How_to_buy_a_franchise.jpg`,
    secondaryTitle: '7 min read',
  },
  {
    title: "14 do's and don'ts when buying a franchise",
    url: `${configValues.HEADER_SERVER_BASE}/business-resources/14-dos-and-donts-during-the-franchise-recruitment-process`,
    imageUrl: `${configValues.HEADER_SERVER_BASE}/wp-content/uploads/2020/07/14-do’s-and-don’ts-during-the-franchise-recruitment-process.png`,
    secondaryTitle: '3 min read',
  },
  {
    title: 'How to assess a franchise culture',
    url: `${configValues.HEADER_SERVER_BASE}/business-resources/how-to-assess-a-franchise-culture`,
    imageUrl: `${configValues.HEADER_SERVER_BASE}/wp-content/uploads/2020/07/How-to-assess-a-franchise-culture.png`,
    secondaryTitle: '4 min read',
  },
];
